import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import AddToBlackList from "../component/blacklist/AddToBlackList";
import SearchBlackList from "../component/blacklist/SearchBlackList";
import { layoutCSS } from "../component/common/commonStyle";
const BlackListPage = () => {
  return (
    <Box sx={layoutCSS}>
      <Typography
        variant="h6"
        sx={{
          mb: 1,
          fontSize: "0.9rem",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        Blacklist Management
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <AddToBlackList />
        </Grid>
        <Grid item xs={12} md={6}>
          <SearchBlackList />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BlackListPage;
